export default "__VITE_PUBLIC_ASSET__9dce9155__"